module.exports = __webpack_public_path__ + "static/media/logo.27b7419d.png";